<ng-container >
  <ng-container *ngIf="column.template; else defaultCell">
    <ng-container
      [ngTemplateOutlet]="column.template"
      [ngTemplateOutletContext]="{ value: element[column.key], row: element }"
    ></ng-container>
  </ng-container>
  <ng-template #defaultCell>
    {{ element[column.key] }}
  </ng-template>
</ng-container>
